<template>
  <div>
    <!--
    <FileViewer :file-type="fileType" :url="url" style="width:100%;height: 100%"></FileViewer>
    -->

    <FileViewer ref="fileViewer" style="width:100%;height: 100%"></FileViewer>

    <el-popover :width="700" placement="bottom">
      <template #reference>
        <el-button style="position: absolute;top: 40px;right: 20px;z-index: 1000">文件信息</el-button>
      </template>

      <div style="background-color: #fffef9;">
        <el-descriptions class="margin-top" title="文件信息" :column="2" size="medium" border>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-user"></i>文件名
            </template>
            {{ currentVersion.ver_name }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-mobile-phone"></i>当前版本
            </template>
            v{{ currentVersion.ver_idx }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-location-outline"></i>文件大小
            </template>
            {{ currentVersion.file_size }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-tickets"></i>当前版本状态
            </template>
            {{ currentVersion['name@status'] }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-office-building"></i>上传用户
            </template>
            {{ currentVersion['name@create_user_id'] }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-office-building"></i>上传时间
            </template>
            {{ currentVersion.create_time }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-office-building"></i>更新用户
            </template>
            {{ currentVersion['name@update_user_id'] }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template #label>
              <i class="el-icon-office-building"></i>更新时间
            </template>
            {{ currentVersion.update_time }}
          </el-descriptions-item>
        </el-descriptions>
        <div style="margin-top: 20px">
          <el-button type="primary" @click="prevPage">上一版本</el-button>
          <el-button type="primary" @click="nextPage">下一版本</el-button>
          <!--
          <el-button type="primary" @click="startVerPage">转到启用版本</el-button>-->
        </div>
        <div style="margin-top: 30px">
          <div class="titleText">历史版本</div>
          <el-table :data="versionList" border style="width: 100%">
            <el-table-column prop="ver_idx" label="版本号" width="70px">
              <template #default="scope">
                v{{ scope.row.ver_idx }}
              </template>
            </el-table-column>
            <el-table-column prop="format_date_time" label="上传时间" width="145px"></el-table-column>
            <el-table-column prop="name@create_user_id" label="上传用户"></el-table-column>
            <el-table-column prop="name@status" label="版本状态" width="100px"></el-table-column>
            <el-table-column prop="file_size" label="文件大小" width="100px"></el-table-column>
            <el-table-column label="操作" width="120px">
              <template #default="scope">
                <el-button link type="primary" style="font-size: 20px" icon="el-icon-download" @click="downloadFile(scope.row)"></el-button>
                <el-button link type="primary" style="font-size: 20px" icon="el-icon-setting"></el-button>
                <el-button v-show="scope.row.status === 'doc_status_edit'" link type="primary" style="font-size: 20px" icon="el-icon-refresh"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-popover>


  </div>
</template>

<script>
import FileViewer from "./FileViewer";

export default {
  name: "FileViewerWithVersions",
  components: {FileViewer},
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fileType: '',
      url:'',
      fileId: '',
      versionList: [],
      currentVersion: {},
      currentSub: 0,
      odiv: null,
      m3dExts:[".step",".stl",".stp",".obj",".igs",".ifc",".mtl",".3ds",".3dm",".3mf",".glb",".dae",".fbx",".bim"],
      ed3dExts:[".sldprt",".prt"]
    }
  },
  methods: {
    setCurrentVersion() {
      this.currentVersion = this.versionList[this.currentSub] || {};
    },
    calcFileType(suffix) {

      console.log('suffix=' + suffix);
      if(this.m3dExts.includes(suffix)){
        return 'm3d';
      }

      if(this.ed3dExts.includes(suffix)){
        return 'ed3d';
      }

      switch (suffix) {
        case '.pdf':
          return 'pdf';
        case '.png':
        case '.jpg':
        case '.jpeg':
        case '.gif':
        case '.bmp':
          return 'img';
        case '.doc':
        case '.docx':
          return 'word';
        case '.xls':
        case '.xlsx':
          return 'excel';
        case '.ppt':
        case '.pptx':
          return 'ppt';
        case '.mp4':
          return 'mp4';
        case '.dxf':
          return 'dxf';
      }

      return 'others'
    },
    downloadFile(appendix) {
      let url = appendix?.sys_file?.url;
      if (!url) {
        return
      }
      let name = appendix.ver_name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },
    prevPage() {
      if (this.currentSub - 1 < 0) {
        this.$message.error("当前已经是最新版本了。")
      } else {
        this.currentSub--
        this.setCurrentVersion();
      }
    },

    nextPage() {
      if (this.currentSub + 1 >= this.versionList.length) {
        this.$message.error("当前已经是最后一个版本了。")
      } else {
        this.currentSub++
        this.setCurrentVersion();
      }
    }
  },
  async created() {

    let suffix = this.parentData.suffix.toLowerCase();
    this.fileType = this.calcFileType(suffix);
    console.log("fileType=" + this.fileType)

    let data = await this.$http('docService.getById', this.parentData)
    console.log("docService.getById.data")
    console.log(data)

    this.versionList = data.ver_list || []
    this.setCurrentVersion();
    this.fileId = this.versionList[0]?.file_id
    this.url = this.versionList[0].sys_file?.url

    console.log("url=" + this.url)
    console.log("fileId=" + this.fileId)

    this.$refs.fileViewer.setFileId(this.fileId)
  }
}
</script>

<style scoped>
.titleText {
  font-size: 30px;
  width: 100%;
  text-align: center;
}

img {
  height: 100%;
  width: auto;
  position: relative;
}

.iconArrow {
  width: 60px;
  height: 55px;
  font-size: 30px;
}

.leftButton {
  position: absolute;
  top: 45%;
  left: 2%;
  margin: auto;
}

.rightButton {
  position: absolute;
  top: 45%;
  right: 37%;
  margin: auto;
}

.frame {
  height: calc(100% - 8px);
  width: 100%;
}
</style>
